
const namespaced = true;

const state = {
  // tags: [],
};

const mutations = {
};

const actions = {
  async addClientTag({ dispatch }, { clientId, siteId, tagId }) {
    const tag = await dispatch(`model/tag/addTagForClientSite`, { clientId, siteId, tagId }, { root: true });

    return tag;
  },
  async addMakerTag({ dispatch }, { makerId, siteId, tagId }) {
    const tag = await dispatch(`model/tag/addTagForMakerSite`, { makerId, siteId, tagId }, { root: true });

    return tag;
  },
  async removeClientTag({ dispatch }, { clientId, siteId, tagId }) {
    const tag = await dispatch(`model/tag/removeTagForClientSite`, { clientId, siteId, tagId }, { root: true });

    return tag;
  },
  async removeMakerTag({ dispatch }, { makerId, siteId, tagId }) {
    const tag = await dispatch(`model/tag/removeTagForMakerSite`, { makerId, siteId, tagId }, { root: true });

    return tag;
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
